import classNames from 'classnames';

export const AIDisclaimer = ({ className = 'p-2' }: { className?: string | null }) => {
  return (
    <div className={classNames('text-ThemeTextPlaceholder', className)}>
      <i className='fal fa-sparkles mr-2' />
      AI generated drafts are for guidance only and should be carefully checked and edited by a human to ensure they are
      factual.
    </div>
  );
};
